import type { VsmContext, PageConfigEntry, PageConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { CustomCssPageConfig } from '../types'
import { name } from '../symbols'

const customCssPageConfig: PageConfigFn<CustomCssPageConfig> = ({ api }: VsmContext) => {
	const appDefinitionIdsWithCustomCss = api.env.getAppDefinitionIdsWithCustomCss()
	const refComponents = api.components.getComponentsByType('RefComponent')

	if (!appDefinitionIdsWithCustomCss.length) {
		return { shouldLoadPageFeature: false }
	}

	const customCssSet = new Set(appDefinitionIdsWithCustomCss)
	const appDefIdSet = new Set<string>()
	let hasCustomCssApp = false
	for (const compId of Object.keys(refComponents)) {
		const appId = api.components.getCompData<{ appDefinitionId?: string }>(compId)?.appDefinitionId
		if (appId) {
			appDefIdSet.add(appId)
			if (customCssSet.has(appId)) hasCustomCssApp = true
		}
	}

	if (!hasCustomCssApp) {
		return { shouldLoadPageFeature: false }
	}

	return {
		shouldLoadPageFeature: true,
		pageConfig: { appsInPage: [...appDefIdSet] },
	}
}

export const pageConfig: PageConfigEntry<CustomCssPageConfig> = {
	name,
	configFactory: customCssPageConfig,
	experiment: 'specs.thunderbolt.vsmPageConfigs',
}
